import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';
import { ReceiptSearch } from 'iconsax-react';
import CourseSuggestion from '@core/components/coursesuggestion/CourseSuggestion';

import classes from './ExploreEmptyState.module.scss';



const ExploreEmptyState = () => {
    return (
        <div className={`${classes.wrapper} d-flex flex-column justify-content-center align-items-center gap-2`}>
            <ReceiptSearch size={40} variant='TwoTone' />
            <h3>No Results Found</h3>
            <p>
                Please make sure your words are spelled correctly or use less or different keywords
            </p>
            <div className='d-flex align-items-center'>
                <LinkButton href={'/explore?featured_contents=true'} kind='simple' >Explore Courses</LinkButton>
                or
                <CourseSuggestion type='short' />
            </div>
        </div>
    );
};

export default ExploreEmptyState;